import { api } from '@/api'

export interface OrderType {
  id: string
  orderNumber: number
  name: string
  slug: string
  isActive: number
  ordersCount: number
  servicesCount: number
  createdAt: string
}

export interface OrderTypesFilters {
  page?: number
  [key: string]: string | number | boolean | undefined | null
}

export interface OrderTypesResponse {
  data: OrderType[]
  meta: {
    message: string
    errors: unknown[]
  }
  pagination: {
    currentPage: number
    perPage: number
    total: number
    lastPage: number
    from: number | null
    to: number | null
  }
}

export function getOrderTypesAction(filters: OrderTypesFilters = {}): Promise<OrderTypesResponse> {
  const params = new URLSearchParams()

  params.append('page', String(filters.page ?? 1))

  Object.entries(filters).forEach(([key, value]) => {
    if (key !== 'page' && value !== '' && value !== null && value !== undefined) {
      params.append(`filter[${key}]`, String(value))
    }
  })

  return api.v2.get<OrderTypesResponse>(`/order-types?${params.toString()}`)
}
